import { useEffect, useState } from 'react';
import { GenericBitmovinPlayerState, UsePlayerParams, UsePlayerResults } from '../types/IPlayer';
import { IBitmovinPlayerWrapper } from '../types/iBasePlayer';
import { useConcurency } from './useConcurency';
import playerService from '../../../helpers/bitmovinPlayer';
import { useAds } from './useAds';

export const usePlayer = ({
    playerType,
    streamingType,
    bookmarkedVodTimeCode,
    VODAsset,
    LinearAsset,
    uiManagerRef,
    isTvod,
    onDestroy,
}: UsePlayerParams): UsePlayerResults => {
    // state
    const [state, setState] = useState<GenericBitmovinPlayerState>({ video: null, error: null });
    const [autoUiVariantResolve, setAutoUiVariantResolve] = useState(true);
    const [streamUrl, setStreamUrl] = useState<string | null>(null);
    const [playerWrapper, setPlayerWrapper] = useState<IBitmovinPlayerWrapper | null>(null);

    // hooks

    // handle stream concurency logic
    const { resolvedUrl, clearConcurrentLock, resolveInitialStream, setNextDelay } = useConcurency(
        streamUrl,
        playerType,
        isTvod,
        VODAsset,
        LinearAsset,
        streamingType,
        bookmarkedVodTimeCode,
        setAutoUiVariantResolve,
        onDestroy,
        setState
    );

    // handle ads logic
    const { handleAVODEvents, handlePlayerOnAdSeeked } = useAds(
        playerType,
        isTvod,
        VODAsset,
        bookmarkedVodTimeCode,
        uiManagerRef,
        setAutoUiVariantResolve
    );

    // useEffect
    useEffect(() => {
        if (state?.error?.status === true) {
            clearConcurrentLock();
        }
    }, [state?.error]);

    useEffect(() => {
        if (playerWrapper) handleAVODEvents(playerWrapper.initializedPlayer);
    }, [VODAsset, playerWrapper]);

    useEffect(() => {
        if (playerWrapper) {
            playerWrapper.initializedPlayer['addEventListener'] = playerWrapper?.initializedPlayer?.on;
            playerWrapper.initializedPlayer['removeEventListener'] = playerWrapper?.initializedPlayer?.off;
        }
    }, [playerWrapper]);

    useEffect(() => {
        if (resolvedUrl) {
            setState((prev) => ({ ...prev, video: { resolvedUrl } }));
        }
    }, [resolvedUrl]);

    return {
        streamUrl,
        state,
        playerWrapper,
        autoUiVariantResolve,
        setAutoUiVariantResolve,
        clearConcurrentLock,
        resolveInitialStream,
        setPlayerWrapper,
        handlePlayerOnAdSeeked,
        setStreamUrl,
        setState,
        setNextDelay,
    };
};
